import { $post } from '@/api/request'

// 沙盘-查询园区详情
export function getDetail (data = {}) {
  return $post({
    url: '/baseParkInfo/sandTable/getDetail',
    data
  })
}